import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { ExamType, ExamTypeTranslationKey, ExamViewModel, RequiredExam } from "../../model/Exam";
import { GetTranslation } from "../../translations/GetTranslation";
import GridTextField from "../common/customGrid/GridTextField";
import TranslatedMessage from "../translations/TranslatedMessage";
import GridCurrencyField from "../common/customGrid/GridCurrencyField";

type ExamFormFieldsProps = {
  exam: ExamViewModel;
  handleFieldChange: (change: Partial<ExamViewModel>) => void;
  isReadOnly?: boolean;
  requiredFieldStatus: RequiredExam;
};

const ExamFormFields = (props: ExamFormFieldsProps) => {
  const { exam, handleFieldChange, isReadOnly, requiredFieldStatus } = props;
  const intl = useIntl();

  return (
    <Grid container={true} spacing={4} direction="column">
      <Grid item={true}>
        <Grid container={true} spacing={4}>
          <GridTextField
            required
            error={requiredFieldStatus.isNameDEEmpty}
            label={GetTranslation(intl, "exam.field.examNameDE")}
            xs={12}
            md={6}
            onChange={(event) => handleFieldChange({ nameDE: event.target.value })}
            value={exam.nameDE}
            readOnly={isReadOnly}
          />
          <GridTextField
            required
            error={requiredFieldStatus.isNameENEmpty}
            label={GetTranslation(intl, "exam.field.examNameEN")}
            xs={12}
            md={6}
            onChange={(event) => handleFieldChange({ nameEN: event.target.value })}
            value={exam.nameEN}
            readOnly={isReadOnly}
          />
          <GridTextField
            required
            error={requiredFieldStatus.isNameFREmpty}
            label={GetTranslation(intl, "exam.field.examNameFR")}
            xs={12}
            md={6}
            onChange={(event) => handleFieldChange({ nameFR: event.target.value })}
            value={exam.nameFR}
            readOnly={isReadOnly}
          />
          <GridTextField
            required
            error={requiredFieldStatus.isNameITEmpty}
            label={GetTranslation(intl, "exam.field.examNameIT")}
            xs={12}
            md={6}
            onChange={(event) => handleFieldChange({ nameIT: event.target.value })}
            value={exam.nameIT}
            readOnly={isReadOnly}
          />
          <GridTextField
            label={GetTranslation(intl, "exam.field.examId")}
            xs={12}
            md={6}
            onChange={(event) => handleFieldChange({ examId: event.target.value })}
            value={exam.examId || ""}
            readOnly={isReadOnly}
          />
        </Grid>
      </Grid>

      <Grid item={true}>
        <Typography variant="h6">
          <TranslatedMessage id="exam.section.specifics" />
        </Typography>

        <Grid container={true} spacing={4}>
          <Grid item={true} xs={12} md={6}>
            <FormControl fullWidth={true}>
              <InputLabel>
                <TranslatedMessage id="exam.field.type" />
              </InputLabel>
              <Select
                required
                value={exam.type}
                onChange={(event) => handleFieldChange({ type: event.target.value as ExamType })}
                error={false}
                readOnly={isReadOnly}
              >
                <MenuItem value={ExamType.Written}>
                  <TranslatedMessage id={ExamTypeTranslationKey[ExamType.Written]} />
                </MenuItem>
                <MenuItem value={ExamType.Oral}>
                  <TranslatedMessage id={ExamTypeTranslationKey[ExamType.Oral]} />
                </MenuItem>
                <MenuItem value={ExamType.TermPaper}>
                  <TranslatedMessage id={ExamTypeTranslationKey[ExamType.TermPaper]} />
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <GridCurrencyField
            label={GetTranslation(intl, "exam.field.examExpenses")}
            xs={12}
            sm={6}
            onFieldChange={(event: any, value: number) => handleFieldChange({ examExpenses: value })}
            value={exam.examExpenses}
            readOnly={isReadOnly}
          />

          <Grid item={true} xs={12} md={6} />
          <GridCurrencyField
            label={GetTranslation(intl, "exam.field.correctionExpenses")}
            xs={12}
            sm={6}
            onFieldChange={(event: any, value: number) => handleFieldChange({ correctionExpenses: value })}
            value={exam.correctionExpenses}
            readOnly={isReadOnly}
          />

          <Grid item={true} xs={12} md={6} />
          <GridCurrencyField
            label={GetTranslation(intl, "exam.field.expertExpenses")}
            xs={12}
            sm={6}
            onFieldChange={(event: any, value: number) => handleFieldChange({ expertExpenses: value })}
            value={exam.expertExpenses}
            readOnly={isReadOnly}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ExamFormFields;
